import React from "react";
import { Box, UnstyledButton } from "@mantine/core";
import { IconPlus } from "@tabler/icons-react";
import styles from "./surface.module.css";

interface EmptyStateCardProps {
  icon: React.ReactNode;
  title: string;
  message?: string;
  actionLabel?: string;
  onAction?: () => void;
}

/**
 * Dashed empty-state placeholder: centered icon tile, title, caption, and
 * an optional pill action button.
 */
export default function EmptyStateCard({
  icon,
  title,
  message,
  actionLabel,
  onAction,
}: EmptyStateCardProps) {
  return (
    <Box className={styles.emptyState}>
      <Box className={styles.emptyStateIconTile}>{icon}</Box>
      <Box className={styles.emptyStateTitle}>{title}</Box>
      {message && <Box className={styles.emptyStateMessage}>{message}</Box>}
      {actionLabel && onAction && (
        <UnstyledButton className={styles.pillButton} onClick={onAction} mt={2}>
          <IconPlus size={15} />
          {actionLabel}
        </UnstyledButton>
      )}
    </Box>
  );
}
